/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mcp_Servers_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Delete \"{name}\"? Its tools will no longer be available in chats." |
*
* @param {Mcp_Servers_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_delete_confirm_description = /** @type {((inputs: Mcp_Servers_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" löschen? Die Tools stehen in Chats nicht mehr zur Verfügung.`)
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"? Its tools will no longer be available in chats.`)
});